export const phoneMask = (value) => {
  const phone = value.replace(/[^0-9]/g, '')
  const hasNineDigits = phone.length === 11
  return `(##) ${hasNineDigits ? '#' : ''}####-####`
}
